export default __webpack_public_path__ + "static/media/2@3x.a05d1d85.png";